import axios from "axios";
import qs from "qs";
import { env } from "@/config/env";

export const api = axios.create({
  baseURL: env.API_URL,
  headers: { "Content-Type": "application/json" },
  // Fall back to demo mode quickly if the backend is unreachable/hanging.
  timeout: 8000,
  // Strapi expects qs-style nested params, e.g. filters[section][$eq]=pk_fashion
  paramsSerializer: (params) =>
    qs.stringify(params, { encodeValuesOnly: true }),
});


// There is no login and no JWT: an order is read with its own token in the
// URL, so a 401/403 is just an error for the caller to surface.

export default api;
